// removed by extract-text-webpack-plugin
module.exports = {"isExpired":"M6gqCa_w1mBMfl1h4WrDP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpiryDate/ExpiryDate.scss
// module id = 1264
// module chunks = 1